import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TaskServiceInterface } from './definitions/task-service-interface';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface AssignResolverResponse {
  task: {
    assignResolver: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class AssignResolverService {
  constructor(private apollo: Apollo) {}

  assignResolver(
    taskId,
    newResolverId,
    mutation: DocumentNode
  ): Observable<FetchResult<AssignResolverResponse>> {
    return this.apollo.mutate<AssignResolverResponse>({
      mutation: mutation,
      variables: {
        taskId,
        newResolverId,
      },
    });
  }
}
